import React from 'react';
import { BookOpen } from 'lucide-react';
import { CourseTree, useCourseTreeGroups } from '../student/learningzone/LearningSidebar';
import { LESSON_PLAN_COURSE_TREE } from './lessonPlanProposal';

// The student Learning Zone's course tree (same component and rows), shown
// on the admin Create Lesson Plan page to choose which course the proposed
// learning focuses on. Selecting a row never leaves the page.
export default function LessonPlanCourseSidebar({ activeView, onSelectCourse }) {
  const { openGroups, toggleGroup, openGroup } = useCourseTreeGroups(LESSON_PLAN_COURSE_TREE);

  const handleSelect = (item) => {
    if (item.children) openGroup(item.id);
    onSelectCourse(item);
  };

  return (
    <aside className="lp-sidebar" aria-label="Courses">
      <h2 className="lp-sidebar-title">
        <BookOpen size={20} aria-hidden="true" />
        Courses
      </h2>
      <CourseTree
        items={LESSON_PLAN_COURSE_TREE}
        activeView={activeView}
        openGroups={openGroups}
        onSelect={handleSelect}
        onToggle={toggleGroup}
      />
    </aside>
  );
}
